module.exports = __webpack_public_path__ + "static/MailSculpt_Hero_01-2260e912cd59c765929c16cda599407d.png";